'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CSSTransitionGroup = require('react-transition-group/CSSTransitionGroup');

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _ModalManager = require('./ModalManager');

var _ModalManager2 = _interopRequireDefault(_ModalManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RouteModalManager = function RouteModalManager(_ref) {
    var children = _ref.children;
    return _react2.default.createElement(
        _CSSTransitionGroup2.default,
        {
            transitionName: 'fade-grow',
            transitionAppear: true,
            transitionEnterTimeout: 600,
            transitionLeaveTimeout: 600,
            transitionAppearTimeout: 600 },
        _react2.default.createElement(
            _ModalManager2.default,
            { key: (0, _lodash.get)(children, ['props', 'route', 'path']) },
            children
        )
    );
};

// Components
// Lib


RouteModalManager.propTypes = {
    children: _propTypes2.default.node
};

exports.default = RouteModalManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/RouteModalManager.js
// module id = 1918
// module chunks = 0